module.exports = __webpack_public_path__ + "static/media/hero.a901c00c.png";